'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Panel = require('./Panel.scss');

var _Panel2 = _interopRequireDefault(_Panel);

var _constants = require('../../shared/constants');

var _SelectOptions = require('../../components/SelectOptions/SelectOptions');

var _SelectOptions2 = _interopRequireDefault(_SelectOptions);

var _DatePicker = require('../../components/DatePicker/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WixStyles = require('../../shared/WixStyles/WixStyles');

var _WixStyles2 = _interopRequireDefault(_WixStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getBackgroundColor = function () {
            var backgroundKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "wixseating-field-fill";

            var siteStyle = Wix.Styles.getStyleParams();
            var defaultBackground = _lodash2.default.get(siteStyle, 'colors.' + backgroundKey + '.rgba');
            return defaultBackground;
        }, _this._getContent = function () {
            var _this$props = _this.props,
                show = _this$props.show,
                type = _this$props.type,
                data = _this$props.data,
                value = _this$props.value,
                defaultValue = _this$props.defaultValue,
                rtl = _this$props.rtl,
                timezone = _this$props.timezone,
                locale = _this$props.locale,
                uniqueId = _this$props.uniqueId;

            var content = null;

            if (show) {
                switch (type) {
                    case _constants.COMPONENT_TYPES.SELECT_TYPE:
                        var options = _lodash2.default.isEmpty(data) ? [] : data;
                        content = _react2.default.createElement(_SelectOptions2.default, { rtl: rtl, defaultValue: defaultValue, options: options, onSelect: _this._onSelect,
                            uniqueId: uniqueId });
                        break;
                    case _constants.COMPONENT_TYPES.DATE_PICKER_TYPE:
                        var _ref = data && data.data || {},
                            excludeDates = _ref.excludeDates;

                        var min = data.min,
                            max = data.max;

                        content = _react2.default.createElement(_DatePicker2.default, { rtl: rtl,
                            uniqueId: uniqueId,
                            defaultValue: defaultValue,
                            excludeDates: excludeDates,
                            selectedDate: value,
                            minDate: min,
                            maxDate: max,
                            timezone: timezone,
                            locale: locale,
                            onSelect: _this._onSelect });
                        break;
                    default:
                        content = null;
                }
            }

            return content;
        }, _this._onSelect = function (_ref2) {
            var value = _ref2.value;

            _this.props.onSelect({ data: { value: value } });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            type = _props.type,
            fieldFill = _props.fieldFill,
            fieldFont = _props.fieldFont,
            fieldColor = _props.fieldColor,
            fieldBorderWidth = _props.fieldBorderWidth,
            isHebrew = _props.isHebrew,
            wixStyleId = _props.wixStyleId;

        (0, _WixStyles2.default)(_constants.FRAME_TYPES.PANEL_FRAME, type, { fieldFill: fieldFill, fieldFont: fieldFont, fieldColor: fieldColor, fieldBorderWidth: fieldBorderWidth }, isHebrew, wixStyleId);
    };

    _class.prototype.render = function render() {
        var _props2 = this.props,
            inline = _props2.inline,
            rtl = _props2.rtl,
            zIndex = _props2.zIndex,
            type = _props2.type,
            uniqueId = _props2.uniqueId,
            fieldFill = _props2.fieldFill;


        return _react2.default.createElement(
            'div',
            { style: { zIndex: zIndex, background: this.getBackgroundColor(fieldFill) },
                className: _Panel2.default.wrapper + ' ' + _Panel2.default[type] + ' ' + _constants.CLASSES.PANEL_WRAPPER + ' ' + (inline ? _Panel2.default.inline : '') + ' ' + (rtl ? _Panel2.default.rtl : ''),
                'data-src-unique-id': uniqueId },
            _react2.default.createElement('div', { className: _Panel2.default.backdrop }),
            this._getContent()
        );
    };

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    rtl: false,
    onBlur: null,
    uniqueId: '',
    wixStyleId: ''
};
exports.default = _class;